// @flow

// import createPickingLineQuantityAndPickedQuantityTableColumn from './components/table/PickingLineQuantityAndPickedQuantityTableColumn';
import createShipmentOrderLineQuantitiesTableColumn from './components/table/ShipmentOrderLineQuantitiesTableColumn';
import createShipmentOrderLineQuantityAndSoldQuantityTableColumn from './components/table/ShipmentOrderLineQuantityAndSoldQuantityTableColumn';

// import SaleOrderLineDiscountCellRenderer from './components/table/SaleOrderLineDiscountCellRenderer';
// import SaleOrderLinesTableRowExtension from './components/table/SaleOrderLinesTableRowExtension';

import shipmentOrderLinesTableConfiguration from './components/configuration/shipmentOrderLinesTableConfiguration';
// import addSaleOrderLineModalConfiguration from './components/configuration/addSaleOrderLineModalConfiguration';

import TradeTimelineItem from '../../trix-web-plugin-wms-trade/web/components/timeline/TradeTimelineItem';

import PickShipmentOrderStockBarcodeField from './components/form/PickShipmentOrderStockBarcodeField';
import PackShipmentOrderStockBarcodeField from './components/form/PackShipmentOrderStockBarcodeField';

// import PackSaleOrderHumanTaskInfo from './components/table/PackSaleOrderHumanTaskInfo';

export const components = {
    // 'tableColumn:pickingLineQuantityAndPickedQuantity': createPickingLineQuantityAndPickedQuantityTableColumn,
    'tableColumn:shipmentOrderLineQuantities': createShipmentOrderLineQuantitiesTableColumn,
    'tableColumn:shipmentOrderLineQuantityAndSoldQuantity': createShipmentOrderLineQuantityAndSoldQuantityTableColumn,

    // // 'tableCellRenderer:saleOrderLineDiscount': SaleOrderLineDiscountCellRenderer,
    // 'tableRowExtension:trix-web-plugin-wms-saleorder.manageSaleOrderPage.container.saleOrderLinesTable': SaleOrderLinesTableRowExtension,
    'configuration:trix-web-plugin-wms-shipmentorder.manageShipmentOrderPage.container.shipmentOrderLinesTable.table': shipmentOrderLinesTableConfiguration,
    // 'configuration:trix-web-plugin-wms-saleorder.manageSaleOrderPage.container.saleOrderLinesTable.action.onAddItem.editor.modal': addSaleOrderLineModalConfiguration,

    'timelineItem:trix-web-plugin-wms-shipmentorder.manageShipmentOrderPage.container.trade': TradeTimelineItem,

    // Human tasks
    'formPaneField:pickShipmentOrderStockBarcode': PickShipmentOrderStockBarcodeField,
    'formPaneField:packShipmentOrderStockBarcode': PackShipmentOrderStockBarcodeField,
    // // 'tableCellRenderer:packSaleOrderHumanTaskInfo': PackSaleOrderHumanTaskInfo,
    
    // // 'configuration:trix-web-plugin-core-human-task.executeHumanTask.container.humanTaskExecutionForm.       WMS_PICK_SALE_ORDERS_STOCK.container.???.form.form': (props: any) => {
    // //     return {
    // //         enableButtons: false,
    // //     }
    // // },
}
